import script from "./SampleRequestFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleRequestFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./SampleRequestFormDialog.vue?vue&type=style&index=0&id=67426446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67426446"]])

export default __exports__